import { z } from "zod"
import { PaginationSchema } from "../../shared/pagination_dtos"
import { QuerySchema } from "../../shared/query_dtos"

export const BackofficeBlockedConversationReasonEnum = {
  skipped: "skipped",
  rejected: "rejected",
} as const

export type BackofficeBlockedConversationReason =
  (typeof BackofficeBlockedConversationReasonEnum)[keyof typeof BackofficeBlockedConversationReasonEnum]

export const GetBackofficeBlockedConversationsSchema = z.object({
  ...PaginationSchema.extend(QuerySchema.shape).shape,
  reason: z.enum(BackofficeBlockedConversationReasonEnum).optional(),
})
